import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, SectionLabel } from "./Reveal";
import { STORE_EMAIL } from "../../data/catalog";

const faqs = [
  ["How do I buy a slab?", "Every card on this site links straight to our eBay store. Hit “Buy on eBay”, pick your slab from the listing and check out securely with eBay."],
  ["What does “You Choose” mean?", "Each listing groups several slabs of the same grade. On eBay, use the dropdown to choose the exact card you want — the price updates for that slab."],
  ["Do you ship outside the UK?", "Yes. We offer tracked UK shipping and worldwide delivery. Postage options and costs are shown at checkout on eBay."],
  ["What is ACE grading?", "ACE Grading is a UK-based card grading company. Cards are assessed and sealed in a tamper-evident slab with a grade from 1 to 10, where 10 is Gem Mint."],
  ["Can I ask about a specific card?", `Of course — email ${STORE_EMAIL} or message us through eBay and we'll help.`],
];

export const Faq = () => (
  <section id="faq" className="border-t border-white/10 bg-[#0B0D13] py-24 lg:py-36" data-testid="faq-section">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-4">
        <SectionLabel n="04">FAQ</SectionLabel>
        <h2 className="font-display text-4xl font-black uppercase leading-[0.9] sm:text-6xl">Good<br />questions.</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-white/10">
              <AccordionTrigger className="py-6 text-left font-display text-lg font-bold hover:no-underline sm:text-2xl" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="max-w-2xl pb-6 text-base leading-relaxed text-slate-300">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
